import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: any) => ({
  view: {
    display: "flex",
    width: "100vw",
    height: "100vh",
    background: "rgb(236, 235, 239)"
  },
  content: {
    padding: "20px",
    height: "100%",
    display: "flex",
    overflow: "hidden",
    gap: "20px",
  },
  dialogHeader: {
    paddingLeft: 20,
    paddingRight: 13,
    ...theme.dialogs.header,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: 60,
    minHeight: 60
  },
  iconBtnStyle: {
    width: 30,
    height: 30,
    borderRadius: 6,
    padding: 0
  },
  headerTitle: {
    ...theme.dialogs.title
  },
  contentArea: {
    display: "flex",
    flexDirection: "column",
    width: "100%"
  },
  mapArea: {
    width: "40%",
  },
  tablesArea: {
    width: "60%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    gap: "20px",
  },
  alertsContainer: {
    width: "100%",
    height: "40%",
    maxHeight: "40%",
    flexGrow: 2,
    overflow: "hidden",
    borderRadius: "4px",
    display: "flex",
    flexDirection: "column"
  },
  errorLogsCard: {
    boxSizing: "border-box",
    height: "100%",
    padding: "0.85rem 1.25rem 0"
  },
  googleCard: {
    padding: "1.25rem"
  },
  listItem: {
    display: "block",
    fontSize: "0.75rem",
    color: theme.tables.tableCell.color,
    paddingLeft: 0
  },
  detailsSectionSecondTitle: {
    display: "inline-block",
    fontSize: "20px",
    fontWeight: 500,
    padding: "0 0 1rem 0",
    fontFamily: "Roboto",
    color: "#4B1C46",
  },

  HVAC: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  operationalView: {
    width: "100%",
    background: "#FFFFFF",
    borderRadius: "4px",
    padding: "20px",
  },
  fullHeight: {
    flex: 1, 
    minHeight: 0,
  },
  maxAlerts: {
    height: '100%',
    maxHeight: '100%'
  }

}));

export default useStyles;
